import './index_mWeb.css';
import { getTeamA, getTeamB, isMatchInScheduled } from '../../../utilities/helper';
import { customizeLeagueTitle } from '../../../utilities/MatchTitleFormat';
import { Image, CountdownTimer, View, Text, Card } from '../../../component';
import React from 'react';
import I18n from '../../../utilities/locale';
import Constants from '../../../constants';
import useTheme from '../../../utilities/hooks/theme';
import { showToast } from '../../../actions/app-actions-types';
import { useDispatch } from 'react-redux';

interface CounterWrapperProps {
  matchStatus?: number;
  onCalledDeadline?: React.MouseEventHandler;
  screen?: string;
  verified?: string;
  theme?: any;
  matchItem?: object;
  isScheduled?: boolean;
  gameName?: string;
}
const CounterWrapper = ({
  matchStatus,
  onCalledDeadline,
  screen,
  verified,
  theme,
  matchItem,
  isScheduled
}: CounterWrapperProps) => {
  const counterTitle = {
    backgroundColor: theme.fixtureMatchItemTimeOut,
    color: theme.fixtureMatchItemTimeOutText
  };
  return (
    <View className="counter_wrapper">
      {isScheduled ? (
        <CountdownTimer
          onCalledDeadline={onCalledDeadline}
          screen={screen}
          matchItem={matchItem}
          style={counterTitle}
          isShowAlert={false}
          //   gameName={gameName}
        />
      ) : matchStatus === 2 && verified ? (
        <Text className="counter_title" style={counterTitle}>
          {I18n.t('Completed')}
        </Text>
      ) : matchStatus === 2 ? (
        <Text className="counter_title" style={counterTitle}>
          {I18n.t('Reviewed')}
        </Text>
      ) : matchStatus === 3 ? (
        <Text className="counter_title" style={counterTitle}>
          {I18n.t('Live')}
        </Text>
      ) : (
        <Text className="counter_title" style={counterTitle}>
          {'Abandoned'}
        </Text>
      )}
    </View>
  );
};

const MatchCardMWeb = ({
  onPressMatchCard,
  onPressAddSubstitute,
  matchItem = {},
  gameName = '',
  gameType = '',
  tabType = ''
}: any) => {
  const { FantasyTheme: theme } = useTheme();
  const dispatch = useDispatch();
  const {
    status: matchStatus,
    verified,
    preSquad = false,
    gameState = 0,
    description = {},
    lineupsOut = false,
    substitutionStatus = '',
    matchTeamLock = '',
    matchTeamLockTime = '',
    matchDelayed = false,
    adminVerified = false
  } = matchItem;
  const matchVerified = gameType === Constants.GameType.FANTASY_YES_NO ? adminVerified : verified;
  const { short = 'Win from Thousands' } = description;
  const teamA = getTeamA(matchItem, gameType) || {};
  const teamB = getTeamB(matchItem, gameType) || {};
  const matchTitle = customizeLeagueTitle(matchItem);

  const isScheduled = isMatchInScheduled({
    matchStatus,
    gameState,
    matchDelayed,
    gameType
  });

  const substitutionStatusMsg =
    matchTeamLockTime && !matchTeamLock
      ? 'substitution window closing soon'
      : substitutionStatus === 'SUBSTITUTED' && matchTeamLock
      ? 'substitutions completed'
      : 'substitution window open';
  const onCalledDeadline = () => {};
  const addBtnSubstituteActiveStatus =
    tabType === 'LIVE' && !(substitutionStatus === 'SUBSTITUTED' && matchTeamLock);

  const lineUpOutColor = {
    color: theme.fixtureMatchLineupOutTitle,
    backgroundColor: theme.fixtureMatchLineupOutBG
  };

  const container = {
    backgroundImage: 'linear-gradient(144deg, #3a434f 21%, #243343 89%)',
    borderColor: '#4b4c52'
  };

  const teamName = {
    color: '#fff'
  };

  const shortDesc = {
    color: '#fff'
  };

  const footer = {
    backgroundImage: 'linear-gradient(174deg, #596779 32%, #4b596b 84%)',
    color: '#fff'
  };

  const header = {
    backgroundImage: 'linear-gradient(178deg, #596779 9%, #4b596b 127%)',
    color: '#fff'
  };

  const substituteBtnLabel = {
    color: '#fff'
  };

  const substituteBtn = {
    backgroundColor: '#005089'
  };

  const _onPressMatchCard = (e: any) => {
    e.stopPropagation();
    if (preSquad) {
      onPressMatchCard({
        ...matchItem,
        teamA,
        teamB,
        matchTitle
      });
    } else dispatch(showToast('squad not out'));
  };

  return (
    <Card onPress={_onPressMatchCard} style={container} className="match_card_container_mWeb">
      <View className="match_card_title_wrapper_mWeb">
        <Text style={header} className="match_card_title_mWeb">{`${customizeLeagueTitle(
          matchItem
        )}`}</Text>
      </View>
      <View className="match_card_content_wrapper_mWeb">
        <View className="match_team_image_container_mWeb">
          <View
            style={{
              width: '45px',
              height: '45px'
            }}>
            <Image
              source={`${teamA?.logoURL}`}
              placeHolderType={'Match'}
              style={{
                width: '100%',
                height: '100%'
              }}
            />
          </View>
          <Text style={teamName} className="match_team_team_mWeb">{`${teamA?.shortName}`}</Text>
        </View>

        <View className="match_team_container_mWeb">
          <View className="match_counter_container_mWeb">
            {isScheduled && <Constants.Svgs.Timer width={'20px'} height={'20px'} />}
            <CounterWrapper
              onCalledDeadline={onCalledDeadline}
              screen={''}
              matchStatus={matchStatus}
              verified={matchVerified}
              theme={theme}
              matchItem={matchItem}
              isScheduled={isScheduled}
              gameName={gameName}
            />
          </View>
          {addBtnSubstituteActiveStatus && gameName == 'SUBSTITUTION' && (
            <View
              onPress={() => onPressAddSubstitute({ ...matchItem, teamA, teamB })}
              style={substituteBtn}
              className="match_add_substitute_button_mWeb">
              <Text style={substituteBtnLabel} className="match_add_substitute_button_label_mWeb">
                {'Add Substitute(s)'}
              </Text>
            </View>
          )}
        </View>

        <View className="match_team_image_container_mWeb">
          <View
            style={{
              width: '45px',
              height: '45px'
            }}>
            <Image
              source={`${teamB?.logoURL}`}
              placeHolderType={'Match'}
              style={{
                width: '100%',
                height: '100%'
              }}
            />
            <View></View>
          </View>
          <Text style={teamName} className="match_team_team_mWeb">{`${teamB?.shortName}`}</Text>
        </View>
      </View>
      {isScheduled && (
        <View style={footer} className="match_card_footer_mWeb">
          {lineupsOut && (
            <Text style={lineUpOutColor} className="match_card_lineup_out_mWeb">
              {I18n.t('LineupOut')}
            </Text>
          )}
          <Text style={shortDesc} className="match_card_short_desc_mWeb">
            {short}
          </Text>
        </View>
      )}
      {tabType === 'LIVE' && substitutionStatusMsg && gameName == 'SUBSTITUTION' && (
        <View style={footer} className="match_card_footer_mWeb">
          <Text style={shortDesc} className="match_card_substitution_msg_mWeb">
            {substitutionStatusMsg}
          </Text>
        </View>
      )}
    </Card>
  );
};
export default React.memo(MatchCardMWeb);
